import { msteams } from '../../api/msteams';
import { IframeWindow } from '.';

export class MsTeams implements msteams.Api {
  constructor(private iframe: IframeWindow) {}

  shareDocument(request: msteams.ShareDocumentRequest): void {
    this.iframe.postMessage({
      command: 'msteams.shareDocument',
      args: request,
    });
  }

  shareMatter(request: msteams.ShareMatterRequest): void {
    this.iframe.postMessage({
      command: 'msteams.shareMatter',
      args: request,
    });
  }

  requestCallback(request: msteams.RequestCallbackRequest): void {
    this.iframe.postMessage({
      command: 'msteams.requestCallback',
      args: request,
    });
  }
}
